/**
 * Reads a company advisory's kind back to the reader.
 *
 * This is deliberately not `@privacy-bee/format`'s `capitalizeWords`, which reads a word carrying no
 * lowercase letter as a shouted paste and rebuilds it — an advisory typed `GDPR_FINE` would come
 * back as "Gdpr_fine". `CompanyAlert.type` carries no enum and no validation beyond "required",
 * so the value is whatever an operator typed: the tail is left exactly as it arrived, and only
 * the underscores that separate words become spaces.
 */
export function advisoryTypeLabel(type: string): string {
    return type.split('_').map((word: string) =>
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
}
